import React, { FC, ReactElement } from 'react';
import { RESTRICTION_ACCESS } from 'src/constants/integrations';
import IntegrationManager from 'src/view/components/IntegrationManager/IntegrationManager';
import { appStore } from '~/mobx/appStore';
import Text, { TEXT } from '~/view/components/Text/Text';
import InputWithTextInsideAfter from '~/view/components/Controls/Inputs/InputWithTextInside/InputWithTextInsideAfter';

interface INutrientField {
  field: string;
  label: string;
  tooltip?: any;
  unit: string;
  value: string;
  onChange: (val?: string) => void;
}

export const NutrientFieldWrapper = ({ label, tooltip = undefined, unit, value, onChange }: INutrientField) => {
  return (
    <IntegrationManager
      setting={appStore.settings?.is_pos ? RESTRICTION_ACCESS.DISABLED : RESTRICTION_ACCESS.ALLOWED}
      wrapperClassName="col-3 my-2"
      withTooltip
    >
      <Text type="block-header" text={label} tooltip={tooltip} />
      <InputWithTextInsideAfter
        type="floatNumber"
        name="text"
        className="nutrient-input py-0 mt-2"
        textProps={{ text: unit }}
        value={value}
        onChangeValue={onChange}
      />
    </IntegrationManager>
  );
};

export default NutrientFieldWrapper;
